module.exports = __webpack_public_path__ + "static/8-65a5719906d7b393315edbcbf462ab6f.jpg";